import {
  mdiAlert,
  mdiArrowUp, mdiBellOutline,
  mdiCached,
  mdiCalendar,
  mdiCheck,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarked,
  mdiCheckCircle,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiCircle,
  mdiClose,
  mdiCloseCircle,
  mdiExclamation, mdiInformation, mdiMagnify,
  mdiMenu,
  mdiMenuUp,
  mdiMenuDown, mdiMinus,
  mdiMinusBox,
  mdiPageFirst,
  mdiPageLast, mdiPaperclip,
  mdiPencil, mdiPlus,
  mdiRadioboxBlank,
  mdiRadioboxMarked,
  mdiStar,
  mdiStarHalfFull,
  mdiStarOutline,
  mdiUnfoldMoreHorizontal,
} from '@mdi/js';

const mdiSvgIcons = {
  iconfont: 'mdiSvg',
  values: {
    // Vuetify default
    complete: mdiCheck,
    cancel: mdiCloseCircle,
    close: mdiClose,
    delete: mdiCloseCircle, // delete (e.g. v-chip close)
    clear: mdiClose,
    success: mdiCheckCircle,
    info: mdiInformation,
    warning: mdiExclamation,
    error: mdiAlert,
    prev: mdiChevronLeft,
    next: mdiChevronRight,
    checkboxOn: mdiCheckboxMarked,
    checkboxOff: mdiCheckboxBlankOutline,
    checkboxIndeterminate: mdiMinusBox,
    delimiter: mdiCircle, // for carousel
    sort: mdiArrowUp,
    expand: mdiChevronDown,
    menu: mdiMenu,
    subgroup: mdiMenuDown,
    dropdown: mdiMenuDown,
    radioOn: mdiRadioboxMarked,
    radioOff: mdiRadioboxBlank,
    edit: mdiPencil,
    ratingEmpty: mdiStarOutline,
    ratingFull: mdiStar,
    ratingHalf: mdiStarHalfFull,
    loading: mdiCached,
    first: mdiPageFirst,
    last: mdiPageLast,
    unfold: mdiUnfoldMoreHorizontal,
    file: mdiPaperclip,
    plus: mdiPlus,
    minus: mdiMinus,

    // 추가
    search: mdiMagnify,
    calendar: mdiCalendar,
    notification: mdiBellOutline,
    menuUp: mdiMenuUp,
    menuDown: mdiMenuDown,
  },
};

export default mdiSvgIcons;